import { useContext } from 'react';
import PropTypes from 'prop-types';

import { FormStepContext } from './FormStepContext';
import { time, budget } from '../../const/formConst';
import ButtonBack from '../form-buttons/ButtonBack';
import ButtonNext from '../form-buttons/ButtonNext';

const FifthStep = () => {
  const { currentStep, register, watch } = useContext(FormStepContext);
  const watchedTime = watch('time_period');
  const watchedBudget = watch('budget');

  return (
    <>
      <div className="laForm__stage-item__sticky-header">
        <div className="laForm__stage-badge">Stage {currentStep.id}</div>
        <h2>
          Time &<strong> budget</strong>
        </h2>
      </div>
      <div className="laForm__stage-item__wrapper">
        <fieldset className="tale-fieldset">
          <legend>Choose a time period:</legend>

          {time.map((item) => (
            <div key={item.id} className="tale-btn-group s-size">
              <input
                type="radio"
                id={item.id}
                value={item.value}
                className="hidden-input"
                {...register('time_period')}
              />
              <label htmlFor={item.id} className="ic-check">
                <div className={item.icon} />
                <span>{item.value}</span>
              </label>
            </div>
          ))}
        </fieldset>
        <fieldset className="tale-fieldset pt">
          <legend>Select the budget your software project will have:</legend>

          {budget.map((item) => (
            <div key={item.id} className="tale-btn-group s-size">
              <input
                type="radio"
                id={item.id}
                value={item.value}
                className="hidden-input"
                {...register('budget')}
              />
              <label htmlFor={item.id} className="ic-check">
                <div className={item.icon} />
                <span>{item.value}</span>
              </label>
            </div>
          ))}
        </fieldset>
      </div>

      <div className="laForm__stage-item__btns">
        <ButtonBack stepId={currentStep.id} />
        <ButtonNext
          stepId={currentStep.id}
          isDisabled={!watchedTime || !watchedBudget}
          buttonId={`${currentStep.id}-time-budget--last-step`}
        />
      </div>
    </>
  );
};

export default FifthStep;

FifthStep.propTypes = {
  currentStep: PropTypes.object,
};
